import { FormField as _FormField, type FormFieldProps } from "./form-field";
import { FormFieldControl, type FormFieldControlProps } from "./form-field-control";
import { FormFieldLabel, type FormFieldLabelProps } from "./form-field-label";

import { withStaticProperties } from "@fhs/utils/src";

export type { FormFieldControlProps, FormFieldProps, FormFieldLabelProps };
export const FormField = withStaticProperties(_FormField, {
  Control: FormFieldControl,
  Label: FormFieldLabel,
});
